import {
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  Heading,
  DrawerBody,
  Stack,
  HStack,
  PinInput,
  PinInputField,
  Button,
  Text,
  FormErrorMessage,
  FormControl
} from '@chakra-ui/react';
import { useState } from 'react';

const VerifyOtpDrawer = ({
  sent,
  phoneNumber,
  isInvalid,
  isSuccess,
  onVerifyOtp,
  verifying,
  onResendOtp,
  resending
}: {
  sent: boolean;
  phoneNumber: string;
  isInvalid: boolean;
  isSuccess: boolean;
  verifying: boolean;
  resending: boolean;
  onVerifyOtp(otp: string): Promise<void>;
  onResendOtp(): Promise<void>;
}) => {
  const [otp, setOtp] = useState('');

  return (
    <Drawer placement='bottom' onClose={() => {}} isOpen={sent}>
      <DrawerOverlay />
      <DrawerContent h={96}>
        <DrawerHeader borderBottomWidth='1px'>
          <Heading as='h5' size='sm' color='#0f172a'>
            Enter OTP Code
          </Heading>
        </DrawerHeader>
        <DrawerBody>
          <Stack spacing={4} w='full'>
            <Text fontSize='sm' color='#475569' mt={4}>
              Enter the six digit code sent to your phone number {phoneNumber}
            </Text>

            <HStack mt={4} gap={4} justifyContent='center'>
              <PinInput
                otp
                value={otp}
                onChange={(value) => setOtp(value)}
                isInvalid={isInvalid}
                size='md'
                type='number'
              >
                <PinInputField />
                <PinInputField />
                <PinInputField />
                <PinInputField />
                <PinInputField />
                <PinInputField />
              </PinInput>
            </HStack>

            {isInvalid && (
              <FormControl
                display='flex'
                justifyContent='center'
                isInvalid={isInvalid}
              >
                <FormErrorMessage mt={3}>Invalid OTP</FormErrorMessage>
              </FormControl>
            )}

            <Text fontSize='sm' color='#475569' textAlign='center' mt={4}>
              Didn't receive it?{' '}
              <Button variant='link' color='#2563eb' onClick={onResendOtp}>
                Resend It
              </Button>
            </Text>

            <Button
              mt={4}
              size='md'
              style={{
                color: '#fff',
                background: isSuccess ? '#15803d' : '#2563eb'
              }}
              onClick={() => onVerifyOtp(otp)}
              isLoading={verifying || resending}
              loadingText='Verifying...'
            >
              {isSuccess ? 'Success' : 'Veryfy'}
            </Button>
          </Stack>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default VerifyOtpDrawer;
